<template>
    <layout-sidebar>
        <div id="app">
            <router-view></router-view>
        </div>
    </layout-sidebar>
</template>

<script>
    export default {
        name: "user-rebate-level"
    }
</script>

<style lang="scss">


</style>